import React, { useRef, useEffect } from "react";

import "./loading.scss";

const Loading = () => {
    return (
        <div className="container loading active ">
            <div className="loading__content">
                <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <h3>Loading...</h3>
            </div>
        </div>
    );
};

export default Loading;
